<template>
  <v-btn
    icon
    variant="text"
    :title="title"
    class="counter-badge-icon"
    @click="$emit('click')"
  >
    <v-badge
      :content="counter"
      :model-value="showBadge"
      color="error"
      overlap
      offset-x="4"
      offset-y="4"
    >
      <v-icon :color="iconColor">{{ icon }}</v-icon>
    </v-badge>
  </v-btn>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  counter: {
    type: [Number, String],
    default: 0,
  },
  icon: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    default: "",
  },
  color: {
    type: String,
    default: "primary",
  },
});

defineEmits(["click"]);

// Computed properties
const showBadge = computed(() => {
  const count = Number(props.counter);
  return !isNaN(count) && count > 0;
});

const iconColor = computed(() => {
  return showBadge.value ? props.color : "default";
});
</script>

<style scoped>
.counter-badge-icon {
  position: relative;
}
</style>
